<template>
	<div id="sign">
		<span id="title">象和•多领域融合气象服务平台</span>
		<div id="signing">
			<div class="input">
				<Input v-model="user" prefix="ios-person-outline" style="width: auto" size="large"/>
			</div>
			<div class="input">
				<Input v-model="password" prefix="ios-lock-outline" style="width: auto" type="password" size="large"/>
			</div>
			<div style="margin: 30px 8px">
				<Button type="default" ghost @click="sign" style="background: #0970e2;width: 265px">登录</Button>
			</div>
		</div>
		<vue-particles
			color="#1645F5"
			:particleOpacity="0.7"
			:particlesNumber="100"
			shapeType="circle"
			:particleSize="4"
			linesColor="#FFFFFF"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="0.5"
			:linesDistance="150"
			:moveSpeed="3"
			:hoverEffect="true"
			hoverMode="grab"
			:clickEffect="true"
			clickMode="push"
		></vue-particles>
	</div>
</template>
<script>
export default {
	data() {
		return {
			user: "",
			password: ""
		};
	},
	methods: {
		sign() {
            $.post(this.$ipConfig.userLogin + `?loginId=${this.user}&pwd=${this.password}`)
                .then(data => {
                    if(data.status == 999){
                        localStorage.setItem('UserLevel', data.data.UserLevel);
                        localStorage.setItem('userName', data.data.UserName);
                        this.$router.push("/huananForecast");
                    }else{
                        this.$Message.error('登陆失败，用户名或者密码错误 !');
                    }
                })
                .fail(x => {
                    this.$Message.error('登陆失败，用户名或者密码错误 !');
                })
			// if (this.user != "admin" || this.password != "admin") {
			// 	console.log("用户，密码错误");
			// 	this.$Message.error({
			// 		content: "用户，密码错误 !"
			// 	});
			// } else {
			// 	this.$router.push("/huananForecast");
			// }
		}
	}
};
</script>
<style scope>
#sign {
	width: 100%;
	height: 100%;
	background: url("../../assets/img/gg.jpg") no-repeat center;
	background-size: 100% 100%;
	text-align: center;
}
#signing {
	position: absolute;
	left: calc(50% - 140px);
	top: 40%;
}
#signing input {
	color: white;
	text-align: center;
	background: none;
	border: none;
	border-bottom: 1px solid #dcdee2;
	border-radius: 0px;
	padding: 4px 35px;
}
.ivu-input-prefix i {
	color: white;
}
.input {
	margin: 20px 0;
}
#title {
	font-size: 35px;
	color: white;
	letter-spacing: 20px;
	position: absolute;
	left: calc(50% - 275px);
	top: 20%;
}
.ivu-input:focus {
	box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/sign.vue